import { s as subscribe } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, v as validate_component } from "../../../../../chunks/ssr.js";
import "../../../../../chunks/api.js";
import { S as Search } from "../../../../../chunks/Search.js";
import { S as Spinner } from "../../../../../chunks/Spinner.js";
import "../../../../../chunks/qualification.js";
import "dayjs";
import { a as allUnits } from "../../../../../chunks/unit.js";
/* empty css                                                                */
import { t as tariffs } from "../../../../../chunks/tariffs.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_allUnits;
  let $$unsubscribe_tariffs;
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => value);
  $$unsubscribe_tariffs = subscribe(tariffs, (value) => value);
  let search = "";
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Search, "Search").$$render(
      $$result,
      { value: search },
      {
        value: ($$value) => {
          search = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${`<div class="mt-5 flex justify-center">${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})}</div>`}`;
  } while (!$$settled);
  $$unsubscribe_allUnits();
  $$unsubscribe_tariffs();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
